export const RECEIPTS_ADD = 'RECEIPTS_ADD';
export const RECEIPTS_REMOVE = 'RECEIPTS_REMOVE';
export const RECEIPTS_SET = 'RECEIPTS_SET';
export const RECEIPTS_SHOW_ADD_MODAL_SET = 'RECEIPTS_SHOW_ADD_MODAL_SET';
export const RECEIPTS_TO_EDIT_SET = 'RECEIPTS_TO_EDIT_SET';
export const RECEIPTS_UPDATE = 'RECEIPTS_UPDATE';
